import { Component, Inject, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
import { Api } from '../../services/api';
import { NgSelectModule } from '@ng-select/ng-select';
import { PermissionService } from '../../services/permission.service';
import {jwtDecode} from 'jwt-decode';

@Component({
  selector: 'app-mdl-new-event',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule],
  templateUrl: './mdl-new-event.html',
  styleUrls: ['./mdl-new-event.css'],
})
export class MdlNewEventComponent implements OnInit {
  ejecutivos: any[] = [];
  relacionados: any[] = [];
  tipoRelacionado: string = '';
  elementosFiltrados: any[] = [];

  showRepeatOptions: boolean = false;
  showReminderOptions: boolean = false;

   isEdit: boolean = false;
  existingTask: any = null;
  currentUserId = '';
  canViewUsers = true;
  disableAssignSelect = true;
  currentUsername = '';
  

  eventData = {
    title: '',
    description: '',
    status: 'pendiente',
    assignedTo: '',
    fechaInicio: this.getTodayDate(),
    fechaFin: this.getTodayDate(),
    horaInicio: '10:00',
    horaFin: '11:00',
    priority: '',
    relatedTo: '',
    ubicacion: '',
    repeatTask: false,
    frecuencia: '',
    fechaInicioRep: this.getTodayDate(),
    fechaFinRep: this.getTodayDate(),
    horaInicioRep: '10:00',
    horaFinRep: '10:00',
    reminderEnabled: false,
    tiempoRecordatorio: '',
  };

  constructor(
    private api: Api,
    private permissionService: PermissionService,
    public dialogRef: MatDialogRef<MdlNewEventComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
      if (data) {
      this.isEdit = data.mode === 'edit';
      this.existingTask = data.existingTask || null;
    }
  }

  ngOnInit() {
    const token = localStorage.getItem('crmtoken');
    if (token) {
      const decoded: any = jwtDecode(token);
      this.currentUserId = decoded.usuario_id || decoded.userId || decoded.sub || '';
      this.currentUsername = decoded.nombre && decoded.apellido
        ? `${decoded.nombre} ${decoded.apellido}`
        : 'Yo';

    }

    this.canViewUsers = this.permissionService.hasPermission('Usuarios y roles','Ver Usuarios');
    if (!this.canViewUsers) {
      this.disableAssignSelect = true;
      this.eventData.assignedTo = this.currentUserId;
      this.ejecutivos=[{
        valor: this.currentUserId,
        nombre: this.currentUsername,
        usuario: {}
      }];
    }else{
     this.cargarUsuarios()
    }

    this.cargarRelacionados();

    if (this.isEdit && this.existingTask) {
      this.prefillFromExistingTask(this.existingTask);
    }
  }

  cargarUsuarios() {
    this.api.getUsers().subscribe({
      next: (response: any) => {
        console.log('🔍 Respuesta completa del backend:', response);

        let usuarios = [];

        if (Array.isArray(response)) {
          usuarios = response;
        } else if (response.users && Array.isArray(response.users)) {
          usuarios = response.users;
        } else if (response.usuarios && Array.isArray(response.usuarios)) {
          usuarios = response.usuarios;
        } else if (response.message && Array.isArray(response.data)) {
          usuarios = response.data;
        } else {
          console.warn('Estructura de respuesta no reconocida:', response);
          usuarios = [];
        }

        console.log('👥 Usuarios extraídos:', usuarios);

        this.ejecutivos = usuarios
          .filter(
            (usuario: any) =>
              usuario.activo === 1 || usuario.activo === undefined
          )
          .map((usuario: any) => ({
            valor: usuario.usuario_id,
            nombre: `${usuario.nombre} ${usuario.apellido}`,
            usuario: usuario,
          }));

        console.log(
          '✅ Usuarios procesados para el dropdown:',
          this.ejecutivos
        );

        if (this.ejecutivos.length > 0 && !this.eventData.assignedTo) {
          this.eventData.assignedTo = this.ejecutivos[0].valor;
          console.log(
            '🎯 Usuario por defecto asignado:',
            this.eventData.assignedTo
          );
        }

        if (this.ejecutivos.length === 0) {
          console.warn('⚠️ No se encontraron usuarios activos');
          this.usarUsuariosDePrueba();
        }
      },
      error: (error) => {
        console.error('❌ Error al cargar usuarios:', error);
        this.usarUsuariosDePrueba();
      },
    });
  }

  cargarRelacionados() {
    this.api.getContacts().subscribe({
      next: (response: any) => {
        const contactos = response.contactos || response || [];
        const contactosMapeados = contactos.map((contacto: any) => ({
          valor: contacto.contacto_id,
          nombre: `👤 ${contacto.nombre} ${contacto.apellido}`,
          tipo: 'CNT',
          icono: 'assets/svg/contact-icon.svg',
          tipoDisplay: 'Contacto',
        }));

        this.api.getAccounts().subscribe({
          next: (accountsResponse: any) => {
            const cuentas = accountsResponse.cuentas || accountsResponse || [];
            const cuentasMapeadas = cuentas.map((cuenta: any) => ({
              valor: cuenta.cuenta_id,
              nombre: `🏢 ${cuenta.nombre_empresa}`,
              tipo: 'ACC',
              icono: 'assets/svg/account-icon.svg',
              tipoDisplay: 'Cuenta',
            }));

            this.api.getOpportunities().subscribe({
              next: (oppResponse: any) => {
                const oportunidades =
                  oppResponse.oportunidades || oppResponse || [];
                const oportunidadesMapeadas = oportunidades.map((opp: any) => ({
                  valor: opp.oportunidad_id,
                  nombre: `💼 ${opp.nombre}`,
                  tipo: 'OPP',
                  icono: 'assets/svg/opportunities-icon.svg',
                  tipoDisplay: 'Oportunidad',
                }));

                this.relacionados = [
                  ...contactosMapeados,
                  ...cuentasMapeadas,
                  ...oportunidadesMapeadas,
                ];

                console.log(
                  '✅ Todos los relacionados cargados:',
                  this.relacionados.length
                );
              },
              error: (error) => {
                console.error('❌ Error al cargar oportunidades:', error);
                this.relacionados = [...contactosMapeados, ...cuentasMapeadas];
              },
            });
          },
          error: (error) => {
            console.error('❌ Error al cargar cuentas:', error);
            this.relacionados = [...contactosMapeados];
          },
        });
      },
      error: (error) => {
        console.error('❌ Error al cargar contactos:', error);
        this.relacionados = [];
      },
    });
  }

  getIconForTipoRelacionado(tipo: string): string {
    const iconos: { [key: string]: string } = {
      CNT: 'assets/svg/contact-icon.svg',
      ACC: 'assets/svg/account-icon.svg',
      OPP: 'assets/svg/opportunities-icon.svg',
    };
    return iconos[tipo] || 'assets/svg/search.svg';
  }

  getPlaceholderPorTipo(): string {
    switch (this.tipoRelacionado) {
      case 'CNT':
        return 'Selecciona un contacto...';
      case 'ACC':
        return 'Selecciona una cuenta...';
      case 'OPP':
        return 'Selecciona una oportunidad...';
      default:
        return 'Buscar...';
    }
  }

  getTipoDisplay(): string {
    switch (this.tipoRelacionado) {
      case 'CNT':
        return 'contactos';
      case 'ACC':
        return 'cuentas';
      case 'OPP':
        return 'oportunidades';
      default:
        return 'elementos';
    }
  }

  onTipoRelacionadoChange() {
    console.log('🔍 Tipo de relación seleccionado:', this.tipoRelacionado);

    this.eventData.relatedTo = '';
    this.elementosFiltrados = [];

    if (this.tipoRelacionado && this.tipoRelacionado !== 'OTRO') {
      this.cargarElementosPorTipo(this.tipoRelacionado);
    } else {
      this.elementosFiltrados = [];
    }
  }

  cargarElementosPorTipo(tipo: string) {
    console.log('🔄 Cargando elementos para tipo:', tipo);

    switch (tipo) {
      case 'CNT':
        this.cargarContactos();
        break;
      case 'ACC':
        this.cargarCuentas();
        break;
      case 'OPP':
        this.cargarOportunidades();
        break;
      default:
        this.elementosFiltrados = [];
    }
  }

  cargarContactos() {
    this.api.getContacts().subscribe({
      next: (response: any) => {
        console.log('📞 Contactos cargados:', response);

        const contactos = response.contactos || response || [];

        this.elementosFiltrados = contactos.map((contacto: any) => ({
          valor: contacto.contacto_id,
          nombre: `${contacto.nombre} ${contacto.apellido}`,
          tipo: 'CNT',
          icono: 'assets/svg/contact-icon.svg',
          tipoDisplay: 'Contacto',
        }));

        console.log(
          '✅ Contactos listos para selección:',
          this.elementosFiltrados.length
        );
      },
      error: (error) => {
        console.error('❌ Error al cargar contactos:', error);
        this.elementosFiltrados = [];
      },
    });
  }

  cargarCuentas() {
    this.api.getAccounts().subscribe({
      next: (response: any) => {
        console.log('🏢 Cuentas cargadas:', response);

        const cuentas = response.cuentas || response || [];

        this.elementosFiltrados = cuentas.map((cuenta: any) => ({
          valor: cuenta.cuenta_id,
          nombre: cuenta.nombre_empresa,
          tipo: 'ACC',
          icono: 'assets/svg/account-icon.svg',
          tipoDisplay: 'Cuenta',
        }));

        console.log(
          '✅ Cuentas listas para selección:',
          this.elementosFiltrados.length
        );
      },
      error: (error) => {
        console.error('❌ Error al cargar cuentas:', error);
        this.elementosFiltrados = [];
      },
    });
  }

  cargarOportunidades() {
    this.api.getOpportunities().subscribe({
      next: (response: any) => {
        console.log('💼 Oportunidades cargadas:', response);

        const oportunidades = response.oportunidades || response || [];

        this.elementosFiltrados = oportunidades.map((opp: any) => ({
          valor: opp.oportunidad_id,
          nombre: opp.nombre,
          tipo: 'OPP',
          icono: 'assets/svg/opportunities-icon.svg',
          tipoDisplay: 'Oportunidad',
        }));

        console.log(
          '✅ Oportunidades listas para selección:',
          this.elementosFiltrados.length
        );
      },
      error: (error) => {
        console.error('❌ Error al cargar oportunidades:', error);
        this.elementosFiltrados = [];
      },
    });
  }

  limpiarSeleccionRelacionado() {
    this.tipoRelacionado = '';
    this.eventData.relatedTo = '';
    this.elementosFiltrados = [];
    console.log('🧹 Selección de relación limpiada');
  }

  usarUsuariosDePrueba() {
    console.log('🔄 Usando usuarios de prueba');
    this.ejecutivos = [
      {
        valor: 'usuario_1',
        nombre: 'Sebastián Pérez',
      },
      {
        valor: 'usuario_2',
        nombre: 'María González',
      },
      {
        valor: 'usuario_3',
        nombre: 'Carlos Rodríguez',
      },
    ];

    if (this.ejecutivos.length > 0 && !this.eventData.assignedTo) {
      this.eventData.assignedTo = this.ejecutivos[0].valor;
    }
  }

  getTodayDate(): string {
    return new Date().toISOString().split('T')[0];
  }

  closeMdl() {
    this.tipoRelacionado = '';
    this.eventData.relatedTo = '';
    this.dialogRef.close(false);
  }

  onRepeatTaskChange() {
    this.showRepeatOptions = this.eventData.repeatTask;
    console.log(
      'Repeat Task:',
      this.eventData.repeatTask,
      'Show Options:',
      this.showRepeatOptions
    );
  }

  onReminderEnabledChange() {
    this.showReminderOptions = this.eventData.reminderEnabled;
    console.log(
      'Reminder Enabled:',
      this.eventData.reminderEnabled,
      'Show Options:',
      this.showReminderOptions
    );
  }

  crearEvento() {
    // 🔒 mismas validaciones que ya tienes...
    if (!this.eventData.title) {
      alert('Por favor ingresa un título para el evento');
      return;
    }
    if (!this.eventData.status) {
      alert('Por favor selecciona el estado del evento');
      return;
    }
    if (!this.eventData.assignedTo && !this.canViewUsers && this.currentUserId) {
      this.eventData.assignedTo = this.currentUserId;
    }
    if (!this.eventData.assignedTo) {
      alert('Por favor asigna el evento a un usuario');
      return;
    }
    if (!this.eventData.priority) {
      alert('Por favor selecciona la prioridad del evento');
      return;
    }

    const fechaInicio = new Date(
      this.eventData.fechaInicio + 'T' + this.eventData.horaInicio
    );
    const fechaFin = new Date(
      this.eventData.fechaFin + 'T' + this.eventData.horaFin
    );

    if (fechaInicio > fechaFin) {
      alert('La fecha de inicio no puede ser mayor que la fecha fin');
      return;
    }

    // relación
    let asociadoTipoFinal = 'OTRO';
    let asociadoIdFinal = '00000000-0000-0000-0000-000000000000';

    if (
      this.eventData.relatedTo &&
      this.tipoRelacionado &&
      this.tipoRelacionado !== 'OTRO'
    ) {
      asociadoTipoFinal = this.tipoRelacionado;
      asociadoIdFinal = this.eventData.relatedTo;
    }

    const payloadBase = {
      titulo: this.eventData.title,
      tipo: 'Evento',
      fecha_vencimiento: this.eventData.fechaInicio,
      hora_vencimiento: this.eventData.horaInicio,
      estado: this.mapearEstadoParaBackend(this.eventData.status),
      prioridad: this.mapearPrioridadParaBackend(this.eventData.priority),
      asociado_tipo: asociadoTipoFinal,
      asociado_id: asociadoIdFinal,
      ejecutivo_id: this.eventData.assignedTo,
      comentarios: this.eventData.description || '',
      // si en el futuro guardas datos_adicionales para evento, los agregas aquí
    };

    if (!this.isEdit) {
      // 🟢 CREAR
      const eventoPayload = {
        ...payloadBase,
        datos_adicionales: {
          fechaInicio: this.eventData.fechaInicio,
          fechaFin: this.eventData.fechaFin,
          horaInicio: this.eventData.horaInicio,
          horaFin: this.eventData.horaFin,
          ubicacion: this.eventData.ubicacion,
          repeatTask: this.eventData.repeatTask,
          frecuencia: this.eventData.frecuencia,
          fechaInicioRep: this.eventData.fechaInicioRep,
          fechaFinRep: this.eventData.fechaFinRep,
          horaInicioRep: this.eventData.horaInicioRep,
          horaFinRep: this.eventData.horaFinRep,
          reminderEnabled: this.eventData.reminderEnabled,
          tiempoRecordatorio: this.eventData.tiempoRecordatorio,
        },
      };

      this.crearEventoBackend(eventoPayload);
    } else {
      // 🟡 EDITAR
      const updatePayload = {
        tarea_id: this.existingTask?.tarea_id,
        ...payloadBase,
      };

      this.actualizarEventoBackend(updatePayload);
    }
  }


  mapearEstadoParaBackend(estado: string): string {
    const mapeo: { [key: string]: string } = {
      pendiente: 'Pendiente',
      en_progreso: 'En progreso',
      vencida: 'Vencida',
      completada: 'Completada',
    };
    return mapeo[estado] || 'Pendiente';
  }

  mapearPrioridadParaBackend(prioridad: string): string {
    const mapeo: { [key: string]: string } = {
      Baja: 'baja',
      Media: 'media',
      Alta: 'alta',
    };
    return mapeo[prioridad] || 'media';
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }

  resetForm() {
    this.tipoRelacionado = '';
    this.showRepeatOptions = false;
    this.showReminderOptions = false;

    this.eventData = {
      title: '',
      description: '',
      status: 'pendiente',
      assignedTo: '',
      fechaInicio: this.getTodayDate(),
      fechaFin: this.getTodayDate(),
      horaInicio: '10:00',
      horaFin: '11:00',
      priority: '',
      relatedTo: '',
      ubicacion: '',
      repeatTask: false,
      frecuencia: '',
      fechaInicioRep: this.getTodayDate(),
      fechaFinRep: this.getTodayDate(),
      horaInicioRep: '10:00',
      horaFinRep: '10:00',
      reminderEnabled: false,
      tiempoRecordatorio: '',
    };
  }

 private calcularFechaRecordatorio(
  fechaBase: string,
  horaBase: string,
  tiempoRecordatorio: string
): string | null {
  if (!fechaBase || !horaBase || !tiempoRecordatorio) return null;

  const base = new Date(`${fechaBase}T${horaBase}`);

  const mapaMinutos: { [key: string]: number } = {
    '5min': 5,
    '15min': 15,
    '30min': 30,
    '1h': 60,
    '1d': 60 * 24,
    '2d': 60 * 24 * 2,
  };

  const minutos = mapaMinutos[tiempoRecordatorio];
  if (!minutos) return null; 

  base.setMinutes(base.getMinutes() - minutos);

  return base.toISOString();
}

private prefillFromExistingTask(tarea: any) {
    this.eventData.title = tarea.titulo || '';
    this.eventData.description = tarea.comentarios || '';

    this.eventData.status = (tarea.estado || 'Pendiente').toLowerCase();
    this.eventData.priority = this.mapearPrioridadFrontend(tarea.prioridad);

    this.eventData.assignedTo = tarea.ejecutivo_id || '';

    if (tarea.fecha_vencimiento) {
      this.eventData.fechaInicio = tarea.fecha_vencimiento;
      this.eventData.fechaFin = tarea.fecha_vencimiento;
    }
    if (tarea.hora_vencimiento) {
      this.eventData.horaInicio = tarea.hora_vencimiento;
      this.eventData.horaFin = tarea.hora_vencimiento;
    }

    // relación (ACC / CNT / OPP)
    if (tarea.asociado_tipo && tarea.asociado_id) {
      this.tipoRelacionado = tarea.asociado_tipo;
      this.eventData.relatedTo = tarea.asociado_id;

      const existente = this.relacionados.find(
        (r) => r.valor === tarea.asociado_id
      );
      if (!existente) {
        this.elementosFiltrados.push({
          valor: tarea.asociado_id,
          nombre:
            tarea.asociado?.nombre ||
            tarea.asociado?.nombre_empresa ||
            tarea.asociado?.titulo ||
            'Relacionado',
          tipo: tarea.asociado_tipo,
          icono: this.getIconForTipoRelacionado(tarea.asociado_tipo),
          tipoDisplay: this.getTipoDisplay(),
        });
      }
    }
  }

  private mapearPrioridadFrontend(prioridad: string | undefined): string {
    if (!prioridad) return '';
    const p = prioridad.toLowerCase();
    if (p === 'baja') return 'Baja';
    if (p === 'alta') return 'Alta';
    return 'Media';
  }

private crearEventoBackend(eventoPayload: any) {
    console.log('📤 Enviando evento al backend:', eventoPayload);

    this.api.createTarea(eventoPayload).subscribe({
      next: (response: any) => {
        console.log('✅ Evento creado exitosamente:', response);
        alert('Evento creado correctamente');
        this.dialogRef.close(true);
      },
      error: (error) => {
        console.error('❌ Error creando evento:', error);
        if (error.error && error.error.message) {
          alert(`Error: ${error.error.message}`);
        } else {
          alert('Error al crear el evento. Por favor intenta nuevamente.');
        }
      },
    });
  }

private actualizarEventoBackend(updatePayload: any) {
    console.log('📤 Actualizando evento:', updatePayload);

    this.api.updateTarea(updatePayload).subscribe({
      next: (response: any) => {
        console.log('✅ Evento actualizado:', response);
        alert('Evento actualizado correctamente');
        this.dialogRef.close(true);
      },
      error: (error) => {
        console.error('❌ Error actualizando evento:', error);
        if (error.error && error.error.message) {
          alert(`Error: ${error.error.message}`);
        } else {
          alert('Error al actualizar el evento. Por favor intenta nuevamente.');
        }
      },
    });
  }

}
